import { render } from "./NewsItem.vue?vue&type=template&id=7e5d403c&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=ts"
export * from "./NewsItem.vue?vue&type=script&lang=ts"

import "./NewsItem.vue?vue&type=style&index=0&id=7e5d403c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e5d403c"

export default script